/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Full_Section1 from "./sections/Full_Section1";
import Full_Section2 from "./sections/Full_Section2";

function FullManagement() {
  usePageMeta({
    title: "Full Property Management Ireland | Spechs",
    description:
      "Complete full property management services across Ireland. Tenant relations, maintenance, compliance — all handled.",
    canonical: "https://www.spechs.ie/property/full/",
  });
  return (
    <SubPageLayout title="Full Property Management">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Full_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Full_Section2 />
      </MKBox>
    </SubPageLayout>
  );
}

export default FullManagement;
